import Dragger from './Dragger';
import DragableList from './DragableList';
import InternalUpload, { LIST_IGNORE } from './Upload';
export { DraggerProps } from './Dragger';
export { RcFile, UploadChangeParam, UploadFile, UploadListProps, UploadProps } from './interface';
const Upload = InternalUpload;
Upload.Dragger = Dragger;
Upload.DragableList = DragableList;
Upload.LIST_IGNORE = LIST_IGNORE;
export default Upload;
